import { ToastContext as DrywallToastContext } from 'drywall';
import { useContext } from 'react';
export { withToast } from 'drywall';
export var ToastContext = DrywallToastContext;
export var useToast = function useToast() {
  return useContext(DrywallToastContext);
};